import React, { useEffect, useState } from 'react';
import styles from './TypingText.module.css';

interface TypingTextProps {
  text: string;
  speed?: number;
  delayAfterEnd?: number;
  showCursor?: boolean;
}

const TypingText: React.FC<TypingTextProps> = ({
  text,
  speed = 70,
  delayAfterEnd = 1000,
  showCursor = true,
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (index < text.length) {
      timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text.charAt(index));
        setIndex((prev) => prev + 1);
      }, speed);
    } else {
      timeout = setTimeout(() => {
        setDisplayedText('');
        setIndex(0);
      }, delayAfterEnd);
    }

    return () => clearTimeout(timeout);
  }, [index, text, speed, delayAfterEnd]);

  return (
    <span>
      {displayedText}
      {showCursor && <span className={styles.blinkingCursor}>|</span>}
    </span>
  );
};

export default TypingText;
